/*
 * @Author: 刘小博
 * @Date: 2023-02-17 15:19:12
 * @LastEditTime: 2023-02-17 15:53:03
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\cost-control\finance-manage\index.js
 * 财务管理
 */
import cashierManageRouter from './modules/cashierManageRouter'
const financeManageRouter = [].concat(cashierManageRouter)

export default financeManageRouter
